import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { ShellPathService } from '../services/shell-path.service';
import { UserService } from '../services/user';

export const practiceAdminGuard: CanActivateFn = (route, state) => {
  const userService = inject(UserService);
  const router = inject(Router);
  const shellPath = inject(ShellPathService);

  return userService.getCurrentUser().pipe(
    map((user) => {
      if (!user) {
        return router.createUrlTree(shellPath.prependBase([''], state));
      }

      // Allow practice_management and owner roles
      if (userService.isPracticeManagement() || userService.isPracticeOwner()) {
        return true;
      }
      return router.createUrlTree(shellPath.prependBase([''], state));
    }),
    catchError((error) => {
      console.error('Practice admin guard error:', error);
      return of(router.createUrlTree(shellPath.prependBase([''], state)));
    }),
  );
};
